var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgChevronPinkLeft(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.41 14.01"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#e1087e",
    d: "M0 7.01l7 7 1.41-1.41-5.59-5.59 5.59-5.6L7 0 0 7v.01z"
  })));
}
export default SvgChevronPinkLeft;